import { VStack } from "@/components/ui/vstack";
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import ModalBase from './ModalBase';
import { backendRequest } from '@/stores/thunks';
import InfoReport from "@/components/common/InfoReport";

export default function ModalReport({ taskId, studioTask, showModal, setShowModal }) {

    let [type, setType] = useState(null);
    let [info, setInfo] = useState('');
    const dispatch = useDispatch()

    const onClose = (isOk) => {
        if (isOk) {
            dispatch(backendRequest('REPORT_WF', '/report/workflow/' + taskId, {
                reportComment: info,
                reportType: type,
                studioTask: studioTask
            }, 'POST', true))
        }
        setShowModal(false)
    }

    return (
        <ModalBase showModal={showModal} setShowModal={onClose} title={'report.title'} info={'report.reason'} onButton={onClose} buttonR={'report.send'} disabled={type==null} buttonL={'report.cancel'}>
            <VStack space='sm' className="m-3 bg-secondary-50 px-4 py-5 rounded-[5px]">
                <InfoReport type={type} setType={setType} info={info} setInfo={setInfo} />
            </VStack>
        </ModalBase>
    );
}